import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-lg modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "alert alert-info" }
const _hoisted_9 = { class: "input-group my-2" }
const _hoisted_10 = {
  key: 0,
  class: "table table-bordered table-hover"
}
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = ["onClick", "onUpdate:modelValue"]
const _hoisted_13 = {
  key: 1,
  type: "text",
  value: 'Save to generate url',
  class: "form-control",
  readonly: ""
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "error" }
const _hoisted_17 = { class: "modal-footer text-right" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]

import { ref, computed, toRef } from 'vue'

    import { copyToClipboard } from '@common/Common'
    import { guid } from '@common/Guid'
    import { ProjectTemplateLink } from '@Projects/Model'

    import { ProjectTemplateLinkReadModel } from '@Projects/Domain/readmodels'
    import type { ProjectTemplateLinksManagerViewModel } from '@Projects/Components/ProjectTemplateLinksManager'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectTemplateLinksManager',
  props: {
    viewModel: {}
  },
  emits: ["update-links"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- local state ----------------

    const newLinkName = ref<string | null>(null)

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const initialized = computed(() => vm.value.initialized)
    const updating = computed(() => vm.value.updating)
    const projectName = computed(() => vm.value.projectName)
    const error = computed(() => vm.value.error)

    const links = computed<ProjectTemplateLinkReadModel[]>(() =>
        vm.value.data?.Links ?? []
    )

    // ---------------- methods ----------------

    function deleteLink(l: ProjectTemplateLinkReadModel)
    {
        const list = vm.value.data?.Links
        if (!list) return

        const index = list.indexOf(l)
        if (index >= 0)
            list.splice(index, 1)
    }

    function copyAccessUrlToClipboard(rm: ProjectTemplateLinkReadModel)
    {
        if (rm.Id <= 0)
            return

        copyToClipboard(rm.AccessUrl)

        const original = rm.AccessUrl
        rm.AccessUrl = 'Copied to clipboard'

        const handle = setTimeout(() =>
        {
            rm.AccessUrl = original
            clearTimeout(handle)
        }, 500)
    }

    function createLink()
    {
        if (!vm.value.data)
            return

        const rm = new ProjectTemplateLinkReadModel()
        rm.AccessKey = guid()
        rm.Views = 0
        rm.Downloads = 0
        rm.Id = 0
        rm.Name = newLinkName.value

        vm.value.data.Links.push(rm)
        newLinkName.value = null
    }

    function handleUpdateLinks()
    {
        vm.value.updating = true

        const data = links.value
            .filter(rm => rm.Name)
            .map(rm =>
            {
                const l = new ProjectTemplateLink()
                l.ProjectId = vm.value.projectId
                l.AccessKey = rm.AccessKey
                l.Name = rm.Name
                l.ProjectTemplateLinkId = rm.Id
                l.Views = rm.Views
                l.Downloads = rm.Downloads
                l.Created = rm.Created
                l.Modified = rm.Modified
                return l
            })

        emit('update-links', vm.value.projectId, data)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "modal-title" }, "Manage Shareable Project Template Links", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (!initialized.value)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_6, [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Loading...", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (initialized.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _cache[3] || (_cache[3] = _createTextVNode(" Share your project '", -1 /* CACHED */)),
                        _createElementVNode("strong", null, _toDisplayString(projectName.value), 1 /* TEXT */),
                        _cache[4] || (_cache[4] = _createTextVNode("' as a template using web links. Start by assigning each link a descriptive name to track its purpose. After naming your links, click 'Save'. The links will then be automatically generated and ready to share. ", -1 /* CACHED */))
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newLinkName).value = $event)),
                          class: "form-control",
                          placeholder: "new link name..."
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            newLinkName.value,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createElementVNode("div", { class: "input-group-append" }, [
                          _createElementVNode("button", {
                            class: "btn btn-outline-secondary",
                            type: "button",
                            onClick: createLink
                          }, "Create link")
                        ])
                      ]),
                      (links.value.length > 0)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_10, [
                            _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "Link name"),
                                _createElementVNode("th", null, "Url (click to copy)"),
                                _createElementVNode("th", null, "Views / Downloads"),
                                _createElementVNode("th")
                              ])
                            ], -1 /* CACHED */)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (l) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: l.Id
                                }, [
                                  _createElementVNode("td", null, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      "onUpdate:modelValue": ($event: any) => ((l.Name) = $event),
                                      placeholder: "Your link name"
                                    }, null, 8 /* PROPS */, _hoisted_11), [
                                      [_vModelText, l.Name]
                                    ])
                                  ]),
                                  _createElementVNode("td", null, [
                                    (l.Name && l.Id > 0)
                                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                          key: 0,
                                          type: "text",
                                          onClick: ($event: any) => (copyAccessUrlToClipboard(l)),
                                          "onUpdate:modelValue": ($event: any) => ((l.AccessUrl) = $event),
                                          title: "Click to copy",
                                          class: "form-control pointer",
                                          readonly: ""
                                        }, null, 8 /* PROPS */, _hoisted_12)), [
                                          [_vModelText, l.AccessUrl]
                                        ])
                                      : _createCommentVNode("v-if", true),
                                    (l.Name && l.Id === 0)
                                      ? (_openBlock(), _createElementBlock("input", _hoisted_13))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _createElementVNode("td", null, [
                                    (l.Name)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(l.Views) + " / " + _toDisplayString(l.Downloads), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _createElementVNode("td", null, [
                                    (l.Name)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "btn btn-secondary",
                                          onClick: ($event: any) => (deleteLink(l))
                                        }, [...(_cache[5] || (_cache[5] = [
                                          _createElementVNode("i", {
                                            class: "fa fa-times",
                                            "aria-hidden": "true"
                                          }, null, -1 /* CACHED */)
                                        ]))], 8 /* PROPS */, _hoisted_15))
                                      : _createCommentVNode("v-if", true)
                                  ])
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(error.value), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  type: "button",
                  disabled: updating.value,
                  onClick: handleUpdateLinks,
                  class: "btn btn-primary"
                }, _toDisplayString(updating.value ? 'Saving...' : 'Save'), 9 /* TEXT, PROPS */, _hoisted_18),
                _createElementVNode("button", {
                  type: "button",
                  disabled: updating.value,
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, "Close", 8 /* PROPS */, _hoisted_19)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})